import { get, findKey, chain } from 'lodash';

var TokenTypes;
(function (TokenTypes) {
  TokenTypes["multiUser"] = "multi-user";
})(TokenTypes || (TokenTypes = {}));
var AuthErrorTypes;
(function (AuthErrorTypes) {
  AuthErrorTypes["noRights"] = "NoRightsError";
})(AuthErrorTypes || (AuthErrorTypes = {}));
var ProfileMenuTab;
(function (ProfileMenuTab) {
  ProfileMenuTab["switchAccount"] = "switchAccount";
  ProfileMenuTab["profile"] = "profile";
})(ProfileMenuTab || (ProfileMenuTab = {}));
var UserRoles;
(function (UserRoles) {
  UserRoles["guest"] = "GUEST";
  UserRoles["readOnly"] = "READONLY";
  UserRoles["user"] = "USER";
  UserRoles["admin"] = "ADMIN";
  UserRoles["superAdmin"] = "SUPER_ADMIN";
})(UserRoles || (UserRoles = {}));
const MfaReqMessage = 'MFA required';
const AccountDisabledMessage = 'Account is disabled';

function extractUserRole(user) {
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const roleStr = get(user, 'role', '');
  const keyOfRole = findKey(UserRoles, k => k === roleStr);
  const role = UserRoles[keyOfRole];
  const scope = get(user, `${data ? 'data.' : ''}permissions.scope`, ['']);
  return role === UserRoles.user && scope.includes(UserRoles.readOnly) ? UserRoles.readOnly : role;
}

function getAvailableRoles(currentUserRole) {
  return chain(UserRoles).map(role => ({
    label: role,
    value: role
  }))
  // Only Super-admin user can set SUPER_ADMIN privileges for other users
  .reject(role => role.value === UserRoles.superAdmin && currentUserRole !== UserRoles.superAdmin).value();
}

const expireOverlay = new class ExpireOverlay {
  constructor() {
    this.shown = false;
  }
  captureClick() {
    if (this.shown) return;
    this.shown = true;
    this.div = document.createElement('div');
    this.div.setAttribute('style', 'position:fixed;left:0;right:0;top:0;bottom:0;background:transparent;z-index:999');
    this.div.onclick = e => {
      this.event = {
        x: e.x,
        y: e.y,
        bubbles: true
      };
      e.preventDefault();
      e.stopPropagation();
      window.postMessage({
        type: 'EXPIRED_TOKEN_REFRESH',
        loading: true
      });
    };
    document.body.appendChild(this.div);
  }
  triggerClick() {
    if (!this.shown || !this.event) return;
    this.shown = false;
    this.div.parentNode.removeChild(this.div);
    window.postMessage({
      type: 'EXPIRED_TOKEN_REFRESH',
      loading: false
    });
    const element = document.elementFromPoint(this.event.x, this.event.y);
    element === null || element === void 0 ? void 0 : element.dispatchEvent(new Event('click', this.event));
    this.event = false;
  }
}();

export { AuthErrorTypes as A, MfaReqMessage as M, ProfileMenuTab as P, TokenTypes as T, UserRoles as U, extractUserRole as a, AccountDisabledMessage as b, expireOverlay as e, getAvailableRoles as g };
